import * as common from "./modules/common.js";
import * as unity from "./modules/unity.js";
import * as campaigns from "./modules/campaigns.js";
import * as webview from "./modules/webview.js";
import * as facebook from "./modules/facebook.js";
import * as payment from "./modules/payments.js";
import * as ads from "./modules/ads.js";

function init(buildUrl, data, onReady) {
    common.init(data);
    unity.init(buildUrl, onReady);
    campaigns.init();
    ads.init();
    payment.init();
}

export {
    init,
    common,
    unity,
    campaigns,
    webview,
    facebook,
    payment,
    ads
};